<template>
  <page-section :title="$t('Profiles_Devices_Title_AuthorisedProfiles')">
    <rest-list :payload="fetchEndpoint">
      <rest-list-column
        v-if="selectedColumns.id"
        prop="id"
        :title="$t('UserProfiles_Field_Id')"
        :route="rowClickRoute"
        :min-width="280"
      />

      <rest-list-column-enum
        v-if="selectedColumns.identifier"
        prop="identifier"
        :enum="profileIdentifiersLabels"
        :title="$t('UserProfiles_Field_Identifier')"
        :min-width="120"
      />

      <rest-list-column
        v-if="
          selectedColumns.customer_id &&
            $store.state.app.features.customerIdEnabled
        "
        prop="customer_id"
        :title="$t('UserProfiles_Field_CustomerId')"
        :min-width="180"
      />

      <rest-list-column
        v-if="selectedColumns.user_id"
        prop="user_id"
        :title="$t('UserProfiles_Field_UserId')"
        :min-width="180"
      />

      <rest-list-column
        v-if="selectedColumns.email"
        prop="email"
        :title="$t('UserProfiles_Field_Email')"
        :min-width="180"
      />

      <rest-list-column
        v-if="selectedColumns.mobile_number"
        prop="mobile_number"
        :title="$t('UserProfiles_Field_MobileNumber')"
        :min-width="180"
      />

      <rest-list-column
        v-if="selectedColumns.whatsapp_number"
        prop="whatsapp_number"
        :title="$t('UserProfiles_Field_WhatsappNumber')"
        :min-width="180"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.email_addressable"
        prop="email_addressable"
        :title="$t('UserProfiles_Field_EmailAddressable')"
        :min-width="140"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.email_subscription"
        prop="email_subscription"
        :title="$t('UserProfiles_Field_EmailSubscription')"
        :min-width="140"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.sms_addressable"
        prop="sms_addressable"
        :title="$t('UserProfiles_Field_SmsAddressable')"
        :min-width="140"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.sms_subscription"
        prop="sms_subscription"
        :title="$t('UserProfiles_Field_SmsSubscription')"
        :min-width="140"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.whatsapp_addressable"
        prop="whatsapp_addressable"
        :title="$t('UserProfiles_Field_WhatsappAddressable')"
        :min-width="140"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.whatsapp_subscription"
        prop="whatsapp_subscription"
        :title="$t('UserProfiles_Field_WhatsappSubscription')"
        :min-width="140"
      />

      <rest-list-column-boolean
        v-if="selectedColumns.archived"
        prop="merge_to"
        :title="$t('UserProfiles_Field_Archived')"
        :min-width="140"
      />

      <el-table-column :width="50" align="center">
        <template slot="header" slot-scope="{}">
          <rest-list-column-settings
            storage-key="profiles-list-columns"
            :title="$t('Profiles_Field_Settings')"
            :columns="columns"
            v-model="selectedColumns"
          />
        </template>
      </el-table-column>
    </rest-list>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import RestListColumnSettings from '@/common/components/rest/RestListColumnSettings'
import { profileIdentifiersLabels } from '@/modules/profiles/enum/ProfileIdentifiersEnum'
import { projectEndpoint, projectRoute } from '@/core/helpers'
export default {
  name: 'DeviceAuthorisedProfilesList',

  components: {
    RestList,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnBoolean,
    RestListColumnSettings,
    PageSection
  },

  data() {
    return {
      selectedColumns: {},
      profileIdentifiersLabels
    }
  },

  props: {
    deviceId: {
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      let params = {
        device_id: this.deviceId,
        authorised: true
      }

      return projectEndpoint({
        method: 'get',
        url: `user-profiles`,
        params: params
      })
    },

    features() {
      return this.$store.state.app.features
    },

    columns() {
      return {
        id: {
          title: this.$t('UserProfiles_Field_Id'),
          defaultValue: true,
          validation: true
        },
        customer_id: {
          title: this.$t('UserProfiles_Field_CustomerId'),
          defaultValue: false,
          validation: this.$store.state.app.features.customerIdEnabled
        },
        identifier: {
          title: this.$t('UserProfiles_Field_Identifier'),
          defaultValue: false,
          validation: true
        },
        user_id: {
          title: this.$t('UserProfiles_Field_UserId'),
          defaultValue: true,
          validation: this.$can('UserPersonalData::Read')
        },
        email: {
          title: this.$t('UserProfiles_Field_Email'),
          defaultValue: false,
          validation: this.$can('UserPersonalData::Read')
        },
        mobile_number: {
          title: this.$t('UserProfiles_Field_MobileNumber'),
          defaultValue: false,
          validation: this.$can('UserPersonalData::Read')
        },
        whatsapp_number: {
          title: this.$t('UserProfiles_Field_WhatsappNumber'),
          defaultValue: false,
          validation:
            this.features.whatsapp && this.$can('UserPersonalData::Read')
        },
        email_addressable: {
          title: this.$t('UserProfiles_Field_EmailAddressable'),
          defaultValue: false,
          validation: true
        },
        email_subscription: {
          title: this.$t('UserProfiles_Field_EmailSubscription'),
          defaultValue: false,
          validation: true
        },
        sms_addressable: {
          title: this.$t('UserProfiles_Field_SmsAddressable'),
          defaultValue: false,
          validation: true
        },
        sms_subscription: {
          title: this.$t('UserProfiles_Field_SmsSubscription'),
          defaultValue: false,
          validation: true
        },
        whatsapp_addressable: {
          title: this.$t('UserProfiles_Field_WhatsappAddressable'),
          defaultValue: false,
          validation: this.features.whatsapp
        },
        whatsapp_subscription: {
          title: this.$t('UserProfiles_Field_WhatsappSubscription'),
          defaultValue: false,
          validation: this.features.whatsapp
        },
        archived: {
          title: this.$t('UserProfiles_Field_Archived'),
          defaultValue: false,
          validation: true
        }
      }
    }
  },

  methods: {
    rowClickRoute(row) {
      return projectRoute({
        name: 'ProfileOverview',
        query: {
          profile_id: row.id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/devices/components/DeviceAuthorisedProfilesList.vue